module.exports = __webpack_public_path__ + "static/media/Q-Hearts.ba06f2f5.svg";